<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content>
  <app-data-exchange-comments
    [comments]="data.comments"
    (commentAdded)="onCommentAdded($event)">
  </app-data-exchange-comments>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" mat-dialog-close>
    {{ 'common.buttons.close' | transloco }}
  </button>
</mat-dialog-actions>
